<template>
	<div class="media-pipe-widget" :tabindex="tabindex" @click="handleClick($event)">
		<div class="media-pipe-widget-header flex-gap-8">
			<slot name="header" />
		</div>
		<div class="media-pipe-widget-stats">
			<slot name="stats" />
		</div>
		<div class="media-pipe-widget-content">
			<slot />
		</div>
		<div class="media-pipe-widget-footer">
			<slot name="footer" />
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "MediaPipelineWidget",
	props: {
		/**
		 * tabindex number
		 *  */
		tabindex: {
			type: Number,
			default: -1
		}
	},
	methods: {
		handleClick(e) {
			/**
			 * Click event
			 *
			 * @event click
			 */
			this.$emit("click", e);
		}
	}
});
</script>
<style lang="scss">
div.media-pipe-widget {
	cursor: pointer;
	display: flex;
	flex-direction: column;
	background-color: var(--dashboard-element-light);
	border-radius: 12px;

	> div.media-pipe-widget-header {
		padding: 16px;
		border-bottom: 1px solid var(--dashboard-border);

		display: flex;
		align-items: center;
	}

	> div.media-pipe-widget-stats {
		padding: 16px;
		border-bottom: 1px solid var(--dashboard-border);
	}

	> div.media-pipe-widget-content {
		padding: 16px;
		border-bottom: 1px solid var(--dashboard-border);
	}

	> div.media-pipe-widget-footer {
		padding: 16px;
	}

	&:active {
		filter: contrast(90%);
	}

	&:hover:not(:active) {
		filter: contrast(95%);
	}

	&:focus {
		box-shadow: inset 0 0 0 2px var(--dashboard-primary);
		outline: none;
	}
}
</style>
